import { apiClient, type Paginated } from '@/core/api';
import type { FeedItem, FeedKind, FeedSource } from './types';

const ITEMS = '/feeds/items/';
const SOURCES = '/feeds/sources/';

export interface FeedItemListParams {
  page?: number;
  kind?: FeedKind;
  source?: number;
  category?: string;
}

export async function listFeedItems(params: FeedItemListParams = {}): Promise<Paginated<FeedItem>> {
  const { data } = await apiClient.get<Paginated<FeedItem>>(ITEMS, { params });
  return data;
}

export async function listFeedSources(): Promise<Paginated<FeedSource>> {
  const { data } = await apiClient.get<Paginated<FeedSource>>(SOURCES);
  return data;
}

/** Trigger a refresh of one source (audited at the integration layer). */
export async function refreshFeedSource(id: number): Promise<{ created: number }> {
  const { data } = await apiClient.post<{ created: number }>(`${SOURCES}${id}/refresh/`);
  return data;
}
